<template>
  <div>
    <div class="course-details-section">
      <b-container class="">
        <!-- pageIsLoading/ -->
        <div v-if="pageIsLoading" class="text-center text-brand my-5 py-5 loadingBox">
          <b-spinner class="align-middle"></b-spinner>
        </div>
        <b-card v-if="!pageIsLoading" class="course-card">
          <b-row>
            <b-col cols="12">
            </b-col>

            <b-col lg="6" md="12" sm="12" style="display: flex;align-items: center;justify-content: center;">
              <div class="course-specifications">
                <div>
                  <h3 class="course-title">{{ data.name }}</h3>
                  <b-row>
                    <b-col cols="12">
                      <i class="fa fa-money mx-1"></i> السعر: <course-price :course="data" />
                    </b-col>
                    <b-col cols="12">
                      <i class="fa fa-clock-o mx-1"></i> عدد الساعات: <strong>{{ data.hours_count }} ساعة</strong>
                    </b-col>
                    <b-col cols="12">
                      <i class="fa fa-calendar mx-1"></i> تاريخ الدورة: <strong>{{ data.start_date }}</strong>
                    </b-col>
                    <!-- <b-col cols="12">
                      <i class="fa fa-list mx-1"></i> مدة الدورة بالأيام: <strong>{{ data.duration }}</strong>
                    </b-col> -->
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col lg="6" md="12" sm="12">
              <img width="100%" :src="data.image || placeholderImage" :alt="data.name" class="course-image">
            </b-col>
            <b-col cols="12">
              <div class="course-details mt-5">
                <p class="course-details-description" v-html="data.description"></p>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="data.is_paid">
            <b-col cols="12">
              <div v-if="data.lessons.length > 0" class="container mt-4">
                <b-table striped hover responsive="sm" stacked="lg" :items="data.lessons" :fields="fields"
                  class="table-data mobile-stacked-table">
                  <template #cell(filename)="data">
                    <div class="oneLine" :title="data.item.filename">
                      {{ (data.item.filename.length > 50) ? (data.item.filename.substring(0, 50) + '...' ):(data.item.filename) }}
                    </div>
                  </template>
                  <template #cell(date)="data">
                    <small>
                      {{ data.item.date }}
                    </small>
                  </template>
                  <template #cell(files)="data">
                    <div>
                      <b-button aria-label="ملفات الدرس" v-if="data.item.files" @click="goToLink(data.item.files)"
                        size="sm" variant="outline-primary">
                        الملفات </b-button>
                      <small v-else class="text-secondary">غير متوفر</small>
                    </div>
                  </template>
                  <template #cell(exam)="data">
                    <b-button aria-label="الاختبار" v-if="data.item.exam" @click="goToLink(data.item.exam)" size="sm"
                      variant="outline-primary">
                      الاختبار
                    </b-button>
                    <small v-else class="text-secondary">غير متوفر</small>
                  </template>
                  <template #cell(live)="data">
                    <b-button aria-label="اللايف" v-if="data.item.live"
                      @click="goToLive(data.item.live, data.item.index)" size="sm" variant="outline-primary">
                      اللايف
                    </b-button>
                    <small v-else class="text-secondary">غير متوفر</small>
                  </template>
                </b-table>
              </div>
              <div v-if="data.lessons.length == 0" class="container mt-4 text-center text-brand">
                الدروس غير متوفره الآن
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
import { sendRequest } from "../utils/RequestHelper.js";
import placeholderImg from '@/assets/images/placeholder.png';
import CoursePrice from "../components/courses/CoursePrice.vue";
import store from "../store/index.js";

export default {
  components: { CoursePrice },
  data() {
    return {
      placeholderImg,
      data: {},
      pageIsLoading: false,
      fields: [
        { key: "id", label: "#" },
        { key: "filename", label: "الاسم", tdClass: "nameCol" }, // إضافة كلاس مخصص
        { key: "date", label: "تاريخ / ساعة" },
        { key: "files", label: "الملفات" },
        { key: "exam", label: "الاختبار" },
        { key: "live", label: "اللايف" }
      ],
      meeting: {
        meetingId: "",
        userName: "",
      }
    };
  },
  methods: {

    goToLink(link) {
      window.open(link, "_blank");
    },
    goToLive(link, lessonIndex) {



      const url = new URL(link);
      const roomID = url.searchParams.get("roomID");

      if (!roomID) {
        alert("الرابط غير صحيح - اتصل بالادارة");
        return;
      }

      // Set the meeting info
      this.meeting.meetingId = roomID;
      this.meeting.userName = this.$store.getters.username || "مستخدم";



      this.$router.push({
        name: 'ZoomLive',
        params: {
          id: this.$route.params.id,
          liveid: this.meeting.meetingId,
          lessonIndex
        }
      });
    },
    loadData() {
      this.pageIsLoading = true;
      let api = ''
      if(this.$route.query.isReg){
        api = 'users/student/courses/'
      }else{
        api = 'courses/courses/'
      }
      sendRequest('get', api + this.$route.params.id, true, null,
        (data) => {
          this.data = data;

          if (!this.data.is_paid) {
            this.$router.push({ name: 'course', params: { id: this.$route.params.id } });
          }
          let i = 0;
          this.data.lessons.forEach(element => {
            element['index'] = i;
            element['id'] = element.id;
            element['filename'] = element.title;
            element['date'] = element.date + ' / ' + element.time.substring(0, 5);
            element['files'] = element.explanation_file;
            element['exam'] = element.test_link;
            element['live'] = element.video_link;
            i++
          });
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );
    }
  },
  watch: {
    $route(to, from) {
      this.username = this.$store.getters.username;
    },
  },
  created() {
    if (store.getters.authToken) {
      this.loadData();
    } else {
      this.$router.push({ name: 'login' })
    }
  }
};
</script>

<style scoped>
.course-details-section {
  padding: 30px 20px;
  background-color: #f5f5f5;
}

.course-card {
  padding: 20px 60px;
  border: none;
}

.table-data.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffcccc !important;
}

.course-image {
  height: 350px;
  object-fit: contain;
}

.course-details-description {
  white-space: pre-line;
}

.course-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}

.course-details {
  font-size: 18px;
  margin-top: 10px;
}

.course-specifications {
  font-size: 21px;
}

.oneLine {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

/* tablet */
@media (max-width: 991.98px) {
  .course-card {
    padding: 20px 10px;
  }

  .course-image {
    height: auto;
    max-height: 260px;
    margin: 24px 0;
  }

  .course-specifications {
    padding: 0 !important;
  }
}

/* mobile */
@media (max-width: 575.98px) {
  .course-details-section {
    padding: 16px 0;
  }

  .course-card {
    padding: 8px 0;
  }

  .course-title {
    font-size: 22px;
  }

  .course-specifications {
    font-size: 16px;
    margin: 0 !important;
  }

  .course-details {
    font-size: 16px;
  }

  /* the stacked lessons table needs every pixel on small phones */
  .course-card .container {
    padding: 0;
  }
}
</style>
